import { Link } from 'react-router-dom'

import preview_light from '/preview_light.png'
import preview_dark from '/preview_dark.png'
import { Button } from '../ui/button'

export default function HeroSection() {
  return (
    <section className='relative overflow-hidden'>
      <div className='absolute inset-0 bg-[radial-gradient(ellipse_60%_50%_at_50%_-10%,hsl(var(--primary)/.18),transparent_60%)]' />

      <div className='mx-auto max-w-7xl px-4 pt-24 pb-12 relative'>
        <div className='text-center space-y-5'>
          <p className='inline-flex items-center gap-2 text-xs border rounded-full px-3 py-1 text-muted-foreground'>
            Nouveau • Inventaire multi-dépôts & factures PDF
          </p>
          <h1 className='text-4xl md:text-6xl font-extrabold tracking-tight'>
            Gérer vos ventes & votre stock{' '}
            <span className='text-primary'>sans friction</span>
          </h1>
          <p className='text-muted-foreground max-w-2xl mx-auto'>
            MOGESAPP centralise ventes, inventaire, facturation et
            encaissements. Simple, rapide, prêt pour votre croissance.
          </p>

          <div className='flex items-center justify-center gap-3'>
            <Link to='/register?redirect=/dashboard'>
              <Button size='lg' className='px-6'>
                Commencer gratuitement
              </Button>
            </Link>
            <Link
              target='_blank'
              to='https://www.youtube.com/watch?v=ET9UATIom0U&list=PLJUG9o0xi8cfBDG4GT9-vQVBYJamHpLWO&index=5'
            >
              <Button size='lg' variant='outline' className='px-6'>
                Voir la démo (2 min)
              </Button>
            </Link>
          </div>

          <div className='text-xs text-muted-foreground mt-3'>
            Essai gratuit • Pas de carte bancaire • Annulation en 1 clic
          </div>
        </div>

        <div className='mt-12 relative'>
          {/*Mode clair*/}
          <img
            src={preview_light}
            alt='Aperçu de MOGESAPP LIGHT'
            className='mx-auto border rounded-xl shadow-xl w-full max-w-5xl dark:hidden block'
            loading='eager'
          />

          {/*Mode sombre */}
          <img
            src={preview_dark}
            alt='Aperçu de MOGESAPP SOMBRE'
            className='mx-auto border rounded-xl shadow-xl w-full max-w-5xl dark:block hidden'
            loading='eager'
          />
          <div className='pointer-events-none absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-background' />
        </div>

        <div className='mt-10 flex flex-wrap items-center justify-center gap-x-8 gap-y-3 text-xs text-muted-foreground'>
          <span className='uppercase tracking-wider'>
            Confiance de +500 commerces
          </span>
          <span>•</span>
          <span>99.9% uptime</span>
          <span>•</span>
          <span>Support réactif</span>
        </div>
      </div>
    </section>
  )
}
